import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Stack } from '@mui/material';

export default function DateRangeField(props) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack direction="row" spacing={1} sx={{ width: '100%' }}>
        <DatePicker
          label="First Day of Travel"
          value={props.start}
          onChange={(date) => props.onChange('start', date)}
          sx={{ flex: 1 }}
          slotProps={{ 
            textField: { 
              id: `field-${props.name}-start`,
              variant: 'outlined', 
              fullWidth: true, 
              InputProps: { readOnly: props.readOnly } 
            } 
          }}
        />
        <DatePicker
          label="Last Day of Travel"
          value={props.end}
          onChange={(date) => props.onChange('end', date)}
          sx={{ flex: 1 }}
          slotProps={{ 
            textField: { 
              id: `field-${props.name}-end`,
              variant: 'outlined', 
              fullWidth: true, 
              InputProps: { readOnly: props.readOnly } 
            } 
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
}
